(() => {
  const states = new Map();
  let queued = false, top = 0;
  function headerOffset() {
    const sticky = document.querySelector('[data-header-sticky]');
    top = sticky ? Math.max(0, sticky.getBoundingClientRect().bottom ?? (parseFloat(getComputedStyle(document.documentElement).getPropertyValue('--header-height')) || sticky.getBoundingClientRect().height)) : 0;
  }
  function update() {
    queued = false;
    headerOffset();
    for (const [nav, state] of states) if (!nav.isConnected) { state.observer?.disconnect(); state.marker.remove(); states.delete(nav); }
    document.querySelectorAll('[data-collection-nav]').forEach(nav => {
      if (states.has(nav)) return;
      const marker = document.createElement('div');
      marker.className = 'vnk-toolbar-placeholder'; marker.setAttribute('aria-hidden','true');
      nav.parentNode.insertBefore(marker,nav);
      const observer = window.ResizeObserver ? new ResizeObserver(schedule) : null;
      observer?.observe(nav);
      states.set(nav,{marker,observer});
    });
    // Read geometry together, then apply positioning without repeated layouts.
    const measurements = [...states].map(([nav,state]) => ({nav,state,rect:state.marker.getBoundingClientRect(),height:nav.offsetHeight,bottom:nav.closest('.collection-products')?.getBoundingClientRect().bottom ?? Infinity}));
    measurements.forEach(({nav,state,rect,height,bottom}) => {
      const pinned = rect.top <= top && bottom > top + height;
      const placeholderHeight = pinned ? height : 0;
      if (state.height !== placeholderHeight) state.marker.style.height = placeholderHeight + 'px';
      if (state.top !== top) nav.style.setProperty('--vnk-toolbar-top',top + 'px');
      if (state.left !== rect.left) nav.style.setProperty('--vnk-toolbar-left',rect.left + 'px');
      if (state.width !== rect.width) nav.style.setProperty('--vnk-toolbar-width',rect.width + 'px');
      if (state.pinned !== pinned) nav.classList.toggle('vnk-fixed-toolbar',pinned);
      Object.assign(state,{height:placeholderHeight,top,left:rect.left,width:rect.width,pinned});
    });
  }
  function schedule() { if (!queued) { queued = true; requestAnimationFrame(update); } }
  function resize() { headerOffset(); schedule(); }
  window.addEventListener('scroll',schedule,{passive:true});
  window.addEventListener('resize',resize,{passive:true});
  window.addEventListener('pageshow',resize);
  document.addEventListener('DOMContentLoaded',resize,{once:true});
  document.addEventListener('shopify:section:load',resize);
  document.addEventListener('shopify:section:unload',schedule);
  // Search disclosures stay expanded while all native filter inputs retain their behavior.
  document.addEventListener('click',event => {
    const summary = event.target.closest?.('.template-search .filter-group summary[data-collapsible-trigger]');
    if (summary) { event.preventDefault(); event.stopPropagation(); }
  },true);
  headerOffset(); update();
})();
